import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Share from '../components/Share';
import './Jobs.css';

function Jobs() {
  return (
    <div className="body">
      <Header
        title="Jobs・仕事一覧 | ASMRキリスト教会"
        description="ASMRキリスト教会の仕事・募集一覧。現在、日曜のオンライン礼拝で司会進行・出演を担当する声優を募集しています。"
        url="https://www.asmrchurch.com/jobs"
        image="https://www.asmrchurch.com/static/images/kirikan-jobs-studio-amen.png"
        subon={false}
      />
      <main className="jobs-page">
        <header className="jobs-hero">
          <p className="jobs-eyebrow">Jobs</p>
          <h1>仕事一覧</h1>
          <p className="jobs-intro">ASMRキリスト教会で、いっしょに活動してくださる方を募集しています。</p>
        </header>
        <section aria-labelledby="jobs-openings">
          <h2 id="jobs-openings">募集中の仕事</h2>
          <a className="jobs-card" href="/jobs/voice-actor">
            <img
              className="jobs-card-image"
              src="/static/images/kirikan-jobs-studio-amen.png"
              alt=""
              width="1536"
              height="1024"
            />
            <div className="jobs-card-content">
              <p className="jobs-eyebrow">募集中・2名</p>
              <h3>声優・オンライン礼拝の司会進行／出演</h3>
              <p>日曜日・月4回 / 1回1時間程度</p>
              <p>月額10,000円（能力に応じて応相談） / 契約期間1年</p>
              <p className="jobs-note">PC貸与あり</p>
              <span className="jobs-card-link">募集詳細を見る →</span>
            </div>
          </a>
        </section>
        <div className="jobs-share">
          <Share
            label="仕事一覧をシェアする"
            title="Jobs・仕事一覧 | ASMRキリスト教会"
            url="https://www.asmrchurch.com/jobs"
            text="ASMRキリスト教会で、いっしょに活動してくださる方を募集しています。"
            image="https://www.asmrchurch.com/static/images/kirikan-jobs-studio-amen.png"
          />
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Jobs;
